import { LambdaAdmin } from "../../common/services/http-service"

const useTicket = () => {

    const postCreateTicket = async (body) => {
        try {
            return await LambdaAdmin({ resource: `soporte/ticket`, method: "POST", data: body });
        } catch (error) {
            const data = error.response.data
            const allMessages = [
                ...data.detalle.internos.flatMap(i => i.mensajes.map(m => m.descripcion)),
                ...data.detalle.errores.flatMap(e => e.mensajes.map(m => m.descripcion)),
                ...data.detalle.advertencias.flatMap(a => a.mensajes.map(m => m.descripcion)),
                ...data.detalle.informativos.flatMap(i => i.mensajes.map(m => m.descripcion)),
                ...data.detalle.exitosos.flatMap(e => e.mensajes.map(m => m.descripcion))
              ].join(" ");
            
            return { data: allMessages }
        }
    };

    const putCreateTicket = async (body) => {
        try {
            return await LambdaAdmin({ resource: `soporte/ticket`, method: "PUT", data: body });
        } catch (error) {
            const data = error.response.data
            const allMessages = [
                ...data.detalle.internos.flatMap(i => i.mensajes.map(m => m.descripcion)),
                ...data.detalle.errores.flatMap(e => e.mensajes.map(m => m.descripcion)),
                ...data.detalle.advertencias.flatMap(a => a.mensajes.map(m => m.descripcion)),
                ...data.detalle.informativos.flatMap(i => i.mensajes.map(m => m.descripcion)),
                ...data.detalle.exitosos.flatMap(e => e.mensajes.map(m => m.descripcion))
              ].join(" ");
            
            return { data: allMessages }
        }
    };

    return {
        postCreateTicket,
        putCreateTicket
    };
};

export default useTicket;